const horizontalTabsInit = (block) => {
    const updateCurrentTab = (key, tabNav) => {
        [...tabNav.querySelectorAll(".bn-horizontal-tabs-tab")].forEach(el => {
            if (el.dataset.tab == key) {
                el.classList.add("--show");
            } else {
                el.classList.remove("--show");
            }
        });
    }

    const updateNav = (key, tabNavButtons) => {
        [...tabNavButtons].forEach(button => {
            if (button.dataset.tabNav == key) {
                button.classList.add("is-style-default");
                button.classList.remove("is-style-secondary");
            } else {
                button.classList.remove("is-style-default");
                button.classList.add("is-style-secondary");
            }
        });
    }

    const horizontalTabs = block ? [block[0].querySelector(".bn-horizontal-tabs")] : Array.from(
        document.querySelectorAll(".bn-horizontal-tabs")
    );

    if (horizontalTabs) { // if at least one exists
        horizontalTabs.forEach(htab => {
            if(htab) {
                let tabNav = htab;
                let tabNavButtons = tabNav.querySelectorAll("span[data-tab-nav]");
                let tabSelect = tabNav.querySelector("select");

                if (tabNav) {
                    tabNav.addEventListener('click', (e) => {
                        if (e.target.getAttribute("data-tab-nav")) {
                            updateNav(e.target.dataset.tabNav, tabNavButtons);
                            updateCurrentTab(e.target.dataset.tabNav, tabNav);

                            tabSelect.value = e.target.dataset.tabNav;
                        }
                    });
                    tabSelect.addEventListener('change', (e) => {
                        updateNav(e.target.value, tabNavButtons);
                        updateCurrentTab(e.target.value, tabNav);
                    });
                }
            }
        });
    }
}


document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        horizontalTabsInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/horizontal-tabs', horizontalTabsInit);
});